var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48516 7.44939L9.78594 15.1898L6.27031 7.44939H2.48516ZM12.0008 16.4352L16.0906 7.44939H7.91094L12.0008 16.4352ZM6.30547 5.95951L8.69609 1.48988H5.62578L2.25078 5.95951H6.30547ZM14.2156 15.1898L21.5164 7.44939H17.7312L14.2156 15.1898ZM8.00469 5.95951H15.9969L13.6062 1.48988H10.3953L8.00469 5.95951ZM17.6961 5.95951H21.7508L18.3758 1.48988H15.3055L17.6961 5.95951ZM19.3484 0.302632L23.8484 6.26215C23.9578 6.40182 24.0086 6.56284 24.0008 6.74519C23.993 6.92755 23.9266 7.08468 23.8016 7.2166L12.5516 19.1356C12.4109 19.2908 12.2273 19.3684 12.0008 19.3684C11.7742 19.3684 11.5906 19.2908 11.45 19.1356L0.2 7.2166C0.075 7.08468 0.00859375 6.92755 0.00078125 6.74519C-0.00703125 6.56284 0.04375 6.40182 0.153125 6.26215L4.65313 0.302632C4.79375 0.100877 4.99297 0 5.25078 0H18.7508C19.0086 0 19.2078 0.100877 19.3484 0.302632Z",
    fill: "#E5AC3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDiamond);
export default __webpack_public_path__ + "static/media/OrangeDiamond.c8a6a61b35074da4c18fb86c64737500.svg";
export { ForwardRef as ReactComponent };